import { ComponentPropsWithoutRef } from "react"
import { Link } from "react-router"

import bloomlifeLogoUrl from "@/assets/bloomlife-logo-full.svg"
import gearImageUrl from "@/assets/gear.svg"
import { useAuthTokensAtom } from "@/data/store"
import { ROUTES } from "@/routes"

type PageProps = ComponentPropsWithoutRef<"div"> & {
  showAppbar?: boolean
}

const Page = ({ children, showAppbar = true, ...otherProps }: PageProps) => {
  const [authTokens] = useAuthTokensAtom()
  const isAuthenticated = authTokens !== null

  return (
    <div className="flex h-full min-h-screen flex-col" {...otherProps}>
      {isAuthenticated && showAppbar && (
        <header className="sticky top-4 z-10 flex h-10 items-center justify-between bg-white px-4">
          <img alt="Bloomlife" src={bloomlifeLogoUrl} width={140} />
          <Link
            to={ROUTES.SETTINGS}
            aria-label="Settings"
            className="flex size-8 items-center justify-center"
          >
            <img alt="" src={gearImageUrl} width={26} height={26} />
          </Link>
        </header>
      )}

      <main className="w-full flex-1 overflow-y-auto px-6 py-4">{children}</main>
    </div>
  )
}

export default Page
